import SharePointUpload from '../components/psc/lib/SharePointUpload'

const RecordSharePointUpload = () => {
    return (
        <SharePointUpload
            entityType="Record"
            apiPath="records"
            statusField="record_status"
        />
    )
};

export default RecordSharePointUpload
